import React from "react";
import styled from "styled-components";
// Assets
import PlasticBagIcon from "../../assets/img/bag.png"
import TrashBagIcon from "../../assets/img/trash.png"
import LaminationRollIcon from "../../assets/img/print.png"
import EcoFriendlyIcon from "../../assets/img/package.png"

export default function ServiceBox({icon, title, subtitle}) {
  let iconSrc;

  switch (icon) {
    case "bag":
      iconSrc = PlasticBagIcon;
      break;
    case "garbage":
      iconSrc = TrashBagIcon; 
      break;
    case "lamination":
      iconSrc = LaminationRollIcon;
      break;
    case "eco":
      iconSrc = EcoFriendlyIcon;
      break;
    default:
      iconSrc = EcoFriendlyIcon;
      break;
  }

  return (
    <Wrapper className="flex flexColumn" >
      <IconStyle>
        <img src={iconSrc} alt={title} width={70} />
      </IconStyle>
      <TitleStyle className="font20 extraBold">{title}</TitleStyle>
      <SubtitleStyle className="font13">{subtitle}</SubtitleStyle>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
`;
const IconStyle = styled.div`
  @media (max-width: 860px) {
    margin: 0 auto;
  }
`;
const TitleStyle = styled.h2`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
  padding: 40px 0;
  @media (max-width: 860px) {
    padding: 20px 0;
  }
`;
const SubtitleStyle = styled.p`
  width: 100%;
  max-width: 300px;
  margin: 0 auto;
`;